import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { AdditionalServicesComponent } from './additional-services.component';
import { AirportServiceComponent } from './sub-components/airport-service/airport-service.component';
import { BaggageServiceComponent } from './sub-components/baggage-service/baggage-service.component';
import { JuniorPilotServiceComponent } from './sub-components/junior-pilot-service/junior-pilot-service.component';
import { PetsServiceComponent } from './sub-components/pets-service/pets-service.component';
import { TravelInsuranceServiceComponent } from './sub-components/travel-insurance-service/travel-insurance-service.component';
import { SupportServiceComponent } from './sub-components/support-service/support-service.component';
import { DutyFreeServiceComponent } from './sub-components/duty-free-service/duty-free-service.component';
import { MyCarValetServiceComponent } from './sub-components/my-car-valet-service/my-car-valet-service.component';
import { LoungeAccessServiceComponent } from './sub-components/lounge-access-service/lounge-access-service.component';
import { SeatReservationServiceComponent } from './sub-components/seat-reservation-service/seat-reservation-service.component';
import { InFlightMealServiceComponent } from './sub-components/in-flight-meal-service/in-flight-meal-service.component';
import { YamatoBaggageServiceComponent } from './sub-components/yamato-baggage-service/yamato-baggage-service.component';

@NgModule({
  declarations: [
    AdditionalServicesComponent,
    BaggageServiceComponent,
    JuniorPilotServiceComponent,
    AirportServiceComponent,
    PetsServiceComponent,
    TravelInsuranceServiceComponent,
    SupportServiceComponent,
    YamatoBaggageServiceComponent,
    DutyFreeServiceComponent,
    MyCarValetServiceComponent,
    LoungeAccessServiceComponent,
    SeatReservationServiceComponent,
    InFlightMealServiceComponent,
  ],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule],
  exports: [AdditionalServicesComponent],
})
export class AdditionalServicesModule {}
